import { useCallback } from 'react';
import type { BaseEventProperties } from '@kushya/shared';
import { useAnalyticsContext } from './analytics-provider';

/**
 * Primary hook for tracking custom events.
 */
export function useAnalytics() {
  const { client, isReady } = useAnalyticsContext();

  const track = useCallback(
    (eventName: string, properties?: BaseEventProperties) => {
      client.track(eventName, properties);
    },
    [client],
  );

  const setSuperProperties = useCallback(
    (properties: Record<string, unknown>) => {
      client.setSuperProperties(properties);
    },
    [client],
  );

  const pageView = useCallback(
    (path?: string) => {
      client.pageView({ path });
    },
    [client],
  );

  return {
    track,
    setSuperProperties,
    pageView,
    isReady,
  };
}
